/**
 * 版本检测和缓存清理工具
 */

const CURRENT_VERSION = '1.0.1'; // 每次修复登录状态问题时递增
const VERSION_KEY = 'app_version';

/**
 * 检查版本并清理旧数据
 */
export function checkVersionAndCleanup() {
  const savedVersion = localStorage.getItem(VERSION_KEY);
  
  if (savedVersion !== CURRENT_VERSION) {
    console.log(`[VersionCheck] 检测到版本变更: ${savedVersion} -> ${CURRENT_VERSION}`);
    
    // 清理可能导致登录状态不一致的数据
    const keysToClean = [
      'accessToken',
      'refreshToken', 
      'tokenKey',
      'happyToken'
    ];
    
    keysToClean.forEach(key => {
      sessionStorage.removeItem(key);
    });
    
    // 更新版本号
    localStorage.setItem(VERSION_KEY, CURRENT_VERSION);
    
    console.log('[VersionCheck] 已清理旧版本数据');
    return true;
  }
  
  return false;
}
